module.exports = __webpack_public_path__ + "img/path-left.01acfeb9.svg";